module.exports = __webpack_public_path__ + "img/notifications-bell-button.56ad0b7d.svg";